module.exports = __webpack_public_path__ + "static/img/Freewheel-Default.8e155ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Freewheel-Default.png
// module id = 1589
// module chunks = 0